import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="record-lookup"
export default class extends Controller {
  static values = { url: String, field: String }

  lookup(event) {
    const api = this.urlValue;
    const type = this.fieldValue;
    let params;

    if (type === 'student') {
      // Get values from both first and last name fields
      const firstName = this.element.querySelector('[name*="first_name"]')?.value.trim();
      const lastName  = this.element.querySelector('[name*="last_name"]')?.value.trim();
      if (!firstName || !lastName) return;
      params = new URLSearchParams({ first_name: firstName, last_name: lastName, type });
    } else if (type === 'parent') {
      // Get values from both email and mobile fields
      const email = this.element.querySelector('[name*="email"]')?.value.trim();
      const mobile  = this.element.querySelector('[name*="mobile"]')?.value.trim();
      if (!email && !mobile) return;
      params = new URLSearchParams({ email: email, mobile: mobile, type });
    } else {
      params = {};
      if (event && event.target) {
        const input = event.target;
        if (input.name && input.value) {
          const match = input.name.match(/\[(.*)\]/);
          const key = match ? match[1] : input.name;
          params[key] = input.value;
        }
      } else if (typeof event === 'object') {
        params = event;
      }
      params = new URLSearchParams(params);
    }

    fetch(`${api}?${params}`)
      .then(r => r.json())
      .then(records => {
        if (records.length > 0) {
          this.showModal(records, type)
        }
      })
  }

  showModal(records, type) {
    const modalBody = document.getElementById("recordLookupModalBody");
    if (!modalBody) return;
    modalBody.innerHTML = records.map(function(record) {
      return '<div class="mb-3 p-2 border rounded ' + (record.deleted ? 'bg-warning-light' : 'bg-light') + '">' +
        '<div><strong>' + record.label + '</strong></div>' +
        '<div>Status: ' + (record.deleted ? 'Deleted' : 'Active') + '</div>' +
        '<div class="mt-2">' +
        '<a href="' + record.show_path + '" class="btn btn-sm btn-info mr-2 record-lookup-view-link" target="_blank">View</a>' +
        (record.recoverable && record.recover_url ? '<button class="btn btn-sm btn-success" data-recover-url="' + record.recover_url + '" data-resource-type="' + type + '" data-source="modal" onclick="window.recoverRecordFromModal && window.recoverRecordFromModal(event)">Recover</button>' : '') +
        '</div>' +
        '</div>';
    }).join('');
    // Google Analytics event for modal popup
    if (window.gtag) {
      window.gtag('event', 'record_lookup_modal_popup', {
        resource_type: type,
        count: records.length
      });
    }
    // Delegate View click event for analytics
    modalBody.addEventListener("click", function(e) {
      if (e.target && e.target.classList.contains("record-lookup-view-link")) {
        if (window.gtag) {
          window.gtag('event', 'record_lookup_view_clicked', {
            resource_type: type
          });
        }
      }
    }, { once: true });
    $("#recordLookupModal").modal("show");
  }
}

// Expose recover handler globally for modal button
window.recoverRecordFromModal = function(event) {
  const btn = event.currentTarget;
  const recoverUrl = btn.getAttribute('data-recover-url');
  const resourceType = btn.getAttribute('data-resource-type');
  const source = btn.getAttribute('data-source') || 'unknown';
  // Google Analytics event for recover click
  if (window.gtag) {
    window.gtag('event', 'record_lookup_recover_clicked', {
      resource_type: resourceType,
      source: source
    });
  }
  btn.disabled = true;
  fetch(recoverUrl, {
    method: 'PATCH',
    headers: { 'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content }
  })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        btn.textContent = 'Recovered!'
        btn.classList.remove('btn-success')
        btn.classList.add('btn-secondary')
      } else {
        btn.textContent = 'Failed'
        btn.classList.remove('btn-success')
        btn.classList.add('btn-danger')
      }
    })
    .catch(() => {
      btn.textContent = 'Error'
      btn.classList.remove('btn-success')
      btn.classList.add('btn-danger')
    })
}
